var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntelliJIdeaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 105,
    viewBox: "0 0 105 105",
    width: 105,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 11.16,
    x2: 58.94,
    y1: 59.21,
    y2: 56.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fc801d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#b07f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#577db3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1e7ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#087cfa"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 89.05,
    x2: 73.12,
    y1: 54.12,
    y2: 6.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe2857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#cb3979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9e4997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7557b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5362c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#386cda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2373e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#1478f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0b7bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087cfa"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 18.72,
    x2: 78.8,
    y1: 26.61,
    y2: 125.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe2857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fe295f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff2d76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff318c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ea3896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b248ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5a63d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087cfa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.27 72.21-14.12-11.15 8.31-15.39 12.49 4.18z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.07 30.09-1.73 55.6-36.98 14.81-20.14-13z",
    fill: "#087cfa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m100.07 30.09-18.3 17.85-23.5-28.83 11.6-13.04z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.22 87.5-29.41 10.63 6.16-21.57 7.98-26.71-21.88-7.32 13.9-38.03 31.42 3.71 32.38 39.73z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 22.5h60v60h-60z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.98 71.16h22.5v3.75h-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.21 34.12v-4.1h-11.19v4.1h3.14v14.16h-3.14v4.1h11.19v-4.1h-3.13v-14.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.94 52.7a8.88 8.88 0 0 1 -4.39-1 10.16 10.16 0 0 1 -2.92-2.36l3.09-3.45a8.86 8.86 0 0 0 1.94 1.64 4 4 0 0 0 2.15.6 2.85 2.85 0 0 0 2.19-.87 4.16 4.16 0 0 0 .8-2.83v-14.43h5v14.65a10.14 10.14 0 0 1 -.55 3.49 6.49 6.49 0 0 1 -4.07 4 9.87 9.87 0 0 1 -3.31.52"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelliJIdeaIcon);
export default __webpack_public_path__ + "static/media/IntelliJ_IDEA_icon.864cdb28b27ae320d3d26cc8ae52c3a4.svg";
export { ForwardRef as ReactComponent };